import styled from "styled-components";

import { ProfileAddressesStyledProps as Props } from "./ProfileAddresses.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { tablet, mobile, desktop } = BREAKPOINTS;

const ProfileAddressesStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background-color: var(--palette-gray-s0-l10);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: 1fr;
  grid-template-areas:
    ".      main   ."
    "footer footer footer";

  @media (min-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height);
  }

  .CommonPlaceholder {
    padding: 0;
    padding-bottom: 3.2rem;
    margin-top: 0;
  }

  .ProfileAddresses {
    &__header {
    }

    &__main {
      grid-area: main;
      display: flex;
      flex-direction: column;
    }

    &__navigation {
      width: 40rem;
      padding: 0;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__navigation,
    &__breadcrumb {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__layout {
      flex: 1;
      display: flex;
      padding-top: 8.8rem;
      padding-bottom: 3.2rem;

      @media (max-width: ${tablet}px) {
        padding-top: 0.8rem;
      }
    }

    &__container {
      padding: 0;
      flex: 1;
      padding: 0 2rem;

      @media (min-width: ${desktop}px) {
        padding: 0 8rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0 1rem;
      }
    }

    &__go-back {
      margin-left: -1.6rem;
    }

    &__wrapper {
      flex: 1;
      padding: 2.4rem;
      background-color: var(--palette-white);
      border-radius: 1.6rem;
      display: flex;
      flex-direction: column;
      min-width: 37.5rem;

      @media (max-width: ${tablet}px) {
        min-width: auto;
      }

      &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 3.2rem;

        .AddNewRecordButton {
          border-radius: 7.2rem;
        }

        @media (max-width: ${tablet + 1}px) {
          padding-bottom: 1.6rem;
        }
      }

      &__title {
        font-size: 2rem;
        line-height: 2.8rem;
        color: var(--palette-black-s0-l10);
        font-weight: 700;

        @media (max-width: ${desktop}px) {
          font-size: 1.4rem;
        }
      }
    }

    &__address-list {
      display: flex;
      flex-direction: column;
      flex: 1;

      .ChooseAddress {
        &__address {
          width: 21.6rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;

          @media (max-width: ${mobile}px) {
            width: 20rem;
          }
        }
      }
    }

    &__footer {
      grid-area: footer;
    }
  }
`;

export default ProfileAddressesStyled;
